// extracted by mini-css-extract-plugin
export default {"container":"PromptInput_container__s2Sm0","input":"PromptInput_input__nA0KA","iconContainer":"PromptInput_iconContainer__9vJWq","disabled":"PromptInput_disabled__aQ7vy"};